module.exports = __webpack_public_path__ + "static/media/RUMN6_G.29071829.jpg";